import { render, staticRenderFns } from "./PropertyGroupNode.vue?vue&type=template&id=5417ded5&scoped=true&lang=pug&"
import script from "./PropertyGroupNode.vue?vue&type=script&lang=ts&"
export * from "./PropertyGroupNode.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyGroupNode.vue?vue&type=style&index=0&id=5417ded5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417ded5",
  null
  
)

export default component.exports